import { accordion } from './accordion'
import { alert } from './alert'
import { avatar } from './avatar'
import { badge } from './badge'
import { button } from './button'
import { card } from './card'
import { carousel } from './carousel'
import { checkbox } from './checkbox'
import { code } from './code'
import { colorPicker } from './color-picker'
import { combobox } from './combobox'
import { datePicker } from './date-picker'
import { dialog } from './dialog'
import { drawer } from './drawer'
import { editable } from './editable'
import { heading } from './heading'
import { hoverCard } from './hover-card'
import { icon } from './icon'
import { input } from './input'
import { label } from './label'
import { link } from './link'
import { menu } from './menu'
import { numberInput } from './number-input'
import { pagination } from './pagination'
import { pinInput } from './pin-input'
import { popover } from './popover'
import { radioButtonGroup } from './radio-button-group'
import { radioGroup } from './radio-group'
import { rangeSlider } from './range-slider'
import { ratingGroup } from './rating-group'
import { segmentGroup } from './segment-group'
import { select } from './select'
import { slider } from './slider'
import { splitter } from './splitter'
import { switchRecipe } from './switch'
import { table } from './table'
import { tabs } from './tabs'
import { tagsInput } from './tags-input'
import { textarea } from './textarea'
import { toast } from './toast'
import { toggleGroup } from './toggle-group'
import { tooltip } from './tooltip'

export const recipes = {
  badge,
  button,
  code,
  heading,
  icon,
  input,
  label,
  link,
  textarea,
}

export const slotRecipes = {
  accordion,
  alert,
  avatar,
  card,
  carousel,
  checkbox,
  colorPicker,
  combobox,
  datePicker,
  dialog,
  drawer,
  editable,
  hoverCard,
  menu,
  numberInput,
  pagination,
  pinInput,
  popover,
  radioGroup,
  rangeSlider,
  radioButtonGroup,
  ratingGroup,
  segmentGroup,
  select,
  slider,
  splitter,
  switchRecipe,
  tabs,
  table,
  tagsInput,
  toast,
  toggleGroup,
  tooltip,
}
